const COMING_SOON_SKUS = new Set(['MNT-001', 'MNT-002']);

export const isComingSoonCartItem = (item = {}) => {
  const sku = String(item.sku || item.productId || '').toUpperCase();
  const name = String(item.name || '').toLowerCase();

  return COMING_SOON_SKUS.has(sku) || name.includes('maintain');
};

export const filterPurchasableCartItems = (items = []) => {
  if (!Array.isArray(items)) return [];
  return items.filter(item => !isComingSoonCartItem(item));
};
